(function () {

  /* =========================================================
     THE FUR — PRODUCT CARD

     DESKTOP IMAGE HOVER:

     IMAGE 1
        ↓
     IMAGE 2
        ↓
     IMAGE 3
        ↓
       STOP

     Image 2 passes through automatically.

     MOUSE LEAVE:
     Reset immediately to Image 1.

     LINKED PRODUCTS:
     - Linked product thumbnails remain clickable
     - Clicking thumbnail opens linked product
     - Does not interfere with image slider
     - Current product thumbnail remains normal link

     MOBILE:
     Image 1 only.
  ========================================================= */


  /* =========================================================
     SETTINGS
  ========================================================= */

  const TRANSITION_DURATION = 420;

  const DESKTOP_BREAKPOINT = 749;



  /* =========================================================
     DESKTOP HOVER CHECK
  ========================================================= */

  function canHover() {

    return (
      window.innerWidth > DESKTOP_BREAKPOINT &&
      window.matchMedia(
        '(hover: hover) and (pointer: fine)'
      ).matches
    );

  }



  /* =========================================================
     INITIALIZE ONE PRODUCT CARD
  ========================================================= */

  function initProductCard(card) {

    if (!card) {
      return;
    }


    /*
     * Prevent duplicate initialization.
     */

    if (
      card.dataset.furProductCardInitialized ===
      'true'
    ) {
      return;
    }


    const media =
      card.querySelector(
        '[data-product-card-media]'
      );


    if (!media) {
      return;
    }


    /*
     * Only first 3 images are used
     * for the card animation.
     */

    const images =
      Array.from(
        media.querySelectorAll(
          '[data-product-card-image]'
        )
      ).slice(0, 3);


    if (!images.length) {
      return;
    }


    card.dataset.furProductCardInitialized =
      'true';



    /* =====================================================
       CARD STATE
    ===================================================== */

    let currentIndex = 0;

    let hovering = false;

    let transitioning = false;

    let transitionTimer = null;



    /* =====================================================
       CLEAR TIMER
    ===================================================== */

    function clearTimer() {

      if (
        transitionTimer === null
      ) {
        return;
      }


      window.clearTimeout(
        transitionTimer
      );


      transitionTimer = null;

    }



    /* =====================================================
       CLEAR ONE IMAGE
    ===================================================== */

    function clearImage(image) {

      if (!image) {
        return;
      }


      image.classList.remove(
        'is-active',
        'is-current',
        'is-next',
        'is-leaving'
      );


      image.style.removeProperty(
        'transition'
      );


      image.style.removeProperty(
        'transform'
      );


      image.style.removeProperty(
        'opacity'
      );


      image.style.removeProperty(
        'visibility'
      );


      image.style.removeProperty(
        'z-index'
      );

    }



    /* =====================================================
       RESET CARD TO IMAGE 1
    ===================================================== */

    function resetCard() {

      clearTimer();


      transitioning = false;

      currentIndex = 0;


      images.forEach(
        function (image) {

          clearImage(
            image
          );

        }
      );


      if (images[0]) {

        images[0].classList.add(
          'is-active'
        );

      }

    }



    /* =====================================================
       FINISH ONE SLIDE
    ===================================================== */

    function finishSlide(
      currentImage,
      nextImage,
      nextIndex
    ) {

      clearImage(
        currentImage
      );


      clearImage(
        nextImage
      );


      nextImage.classList.add(
        'is-active'
      );


      currentIndex =
        nextIndex;


      transitioning =
        false;


      /*
       * If mouse left while the
       * animation was running,
       * immediately return to image 1.
       */

      if (!hovering) {

        resetCard();

        return;

      }


      /*
       * Continue until final available image.
       *
       * 3 images:
       * 1 → 2 → 3 → STOP
       *
       * 2 images:
       * 1 → 2 → STOP
       */

      if (
        currentIndex <
        images.length - 1
      ) {

        window.requestAnimationFrame(
          function () {

            if (hovering) {

              slideToNext();

            }

          }
        );

      }

    }



    /* =====================================================
       RUN ONE SLIDE

       CURRENT:
       0 → -100%

       NEXT:
       100% → 0
    ===================================================== */

    function runSlide(
      currentImage,
      nextImage,
      nextIndex
    ) {

      if (
        transitioning ||
        !hovering ||
        !currentImage ||
        !nextImage
      ) {
        return;
      }


      transitioning = true;



      /* =================================================
         CURRENT IMAGE
      ================================================== */

      clearImage(
        currentImage
      );


      currentImage.classList.add(
        'is-current'
      );


      currentImage.style.zIndex =
        '3';


      currentImage.style.opacity =
        '1';


      currentImage.style.visibility =
        'visible';


      currentImage.style.transition =
        'none';


      currentImage.style.transform =
        'translate3d(0, 0, 0)';



      /* =================================================
         NEXT IMAGE

         Start outside right.
      ================================================== */

      clearImage(
        nextImage
      );


      nextImage.classList.add(
        'is-next'
      );


      nextImage.style.zIndex =
        '4';


      nextImage.style.opacity =
        '1';


      nextImage.style.visibility =
        'visible';


      nextImage.style.transition =
        'none';


      nextImage.style.transform =
        'translate3d(100%, 0, 0)';



      /*
       * Force browser layout so the
       * starting positions are committed.
       */

      void media.offsetWidth;



      /* =================================================
         TRANSITION
      ================================================== */

      const transition =
        'transform ' +
        TRANSITION_DURATION +
        'ms cubic-bezier(0.76, 0, 0.24, 1)';


      currentImage.style.transition =
        transition;


      nextImage.style.transition =
        transition;



      /* =================================================
         START SLIDE
      ================================================== */

      window.requestAnimationFrame(
        function () {

          window.requestAnimationFrame(
            function () {

              if (!hovering) {
                return;
              }


              /*
               * Current image exits left.
               */

              currentImage.style.transform =
                'translate3d(-100%, 0, 0)';


              /*
               * Next image enters from right.
               */

              nextImage.style.transform =
                'translate3d(0, 0, 0)';

            }
          );

        }
      );



      /* =================================================
         FINISH
      ================================================== */

      transitionTimer =
        window.setTimeout(
          function () {

            transitionTimer =
              null;


            finishSlide(
              currentImage,
              nextImage,
              nextIndex
            );

          },

          TRANSITION_DURATION + 30
        );

    }



    /* =====================================================
       MOVE TO NEXT IMAGE
    ===================================================== */

    function slideToNext() {

      if (
        transitioning ||
        !hovering
      ) {
        return;
      }


      /*
       * Already at final image.
       */

      if (
        currentIndex >=
        images.length - 1
      ) {
        return;
      }


      const nextIndex =
        currentIndex + 1;


      const currentImage =
        images[currentIndex];


      const nextImage =
        images[nextIndex];


      runSlide(
        currentImage,
        nextImage,
        nextIndex
      );

    }



    /* =====================================================
       CARD MOUSE ENTER
    ===================================================== */

    function handleMouseEnter() {

      if (!canHover()) {
        return;
      }


      /*
       * Reset first so every hover
       * starts from Image 1.
       */

      hovering = false;


      resetCard();


      hovering = true;


      /*
       * No animation required when
       * product has only one image.
       */

      if (
        images.length <= 1
      ) {
        return;
      }


      slideToNext();

    }



    /* =====================================================
       CARD MOUSE LEAVE
    ===================================================== */

    function handleMouseLeave() {

      if (!canHover()) {
        return;
      }


      hovering = false;


      resetCard();

    }



    /* =====================================================
       ADD CARD EVENTS
    ===================================================== */

    card.addEventListener(
      'mouseenter',
      handleMouseEnter
    );


    card.addEventListener(
      'mouseleave',
      handleMouseLeave
    );



    /* =====================================================
       LINKED PRODUCT CONTROLS
    ===================================================== */

    const linkedColors =
      card.querySelectorAll(
        '.fur-product-card__linked-color'
      );


    linkedColors.forEach(
      function (linkedColor) {


        /* =================================================
           CLICK

           Linked products are real anchors now.
           We DON'T prevent default navigation.
        ================================================== */

        linkedColor.addEventListener(
          'click',
          function (event) {

            /*
             * Prevent another delegated card-click
             * handler elsewhere in the theme from
             * hijacking this click.
             */

            event.stopPropagation();

          }
        );



        /* =================================================
           POINTER DOWN

           Important for collection layouts that
           use drag/scroll interactions.
        ================================================== */

        linkedColor.addEventListener(
          'pointerdown',
          function (event) {

            event.stopPropagation();

          }
        );



        /* =================================================
           MOUSE DOWN
        ================================================== */

        linkedColor.addEventListener(
          'mousedown',
          function (event) {

            event.stopPropagation();

          }
        );



        /* =================================================
           TOUCH START
        ================================================== */

        linkedColor.addEventListener(
          'touchstart',
          function (event) {

            event.stopPropagation();

          },
          {
            passive: true
          }
        );

      }
    );



    /* =====================================================
       KEYBOARD FOCUS

       When keyboard focus enters card,
       don't accidentally leave images
       in an animation state.
    ===================================================== */

    card.addEventListener(
      'focusin',
      function () {

        if (!canHover()) {
          return;
        }


        if (
          card.matches(':hover')
        ) {
          return;
        }


        resetCard();

      }
    );



    /* =====================================================
       INITIAL STATE
    ===================================================== */

    resetCard();

  }



  /* =========================================================
     INITIALIZE ALL PRODUCT CARDS
  ========================================================= */

  function initProductCards(root) {

    const context =
      root || document;


    /*
     * Root itself may be a card.
     */

    if (
      context.matches &&
      context.matches(
        '[data-fur-product-card]'
      )
    ) {

      initProductCard(
        context
      );

    }


    /*
     * Find cards inside root.
     */

    if (
      context.querySelectorAll
    ) {

      const cards =
        context.querySelectorAll(
          '[data-fur-product-card]'
        );


      cards.forEach(
        function (card) {

          initProductCard(
            card
          );

        }
      );

    }

  }



  /* =========================================================
     RESET ALL CARDS ON MOBILE / RESIZE
  ========================================================= */

  function resetCardsForViewport() {

    /*
     * CSS already forces Image 1 on mobile.
     *
     * This removes any inline styles that
     * might remain after resizing from
     * desktop to mobile.
     */

    if (
      window.innerWidth >
      DESKTOP_BREAKPOINT
    ) {
      return;
    }


    const cards =
      document.querySelectorAll(
        '[data-fur-product-card]'
      );


    cards.forEach(
      function (card) {

        const images =
          card.querySelectorAll(
            '[data-product-card-image]'
          );


        images.forEach(
          function (image) {

            image.classList.remove(
              'is-active',
              'is-current',
              'is-next',
              'is-leaving'
            );


            image.style.removeProperty(
              'transition'
            );


            image.style.removeProperty(
              'transform'
            );


            image.style.removeProperty(
              'opacity'
            );


            image.style.removeProperty(
              'visibility'
            );


            image.style.removeProperty(
              'z-index'
            );

          }
        );


        if (images[0]) {

          images[0].classList.add(
            'is-active'
          );

        }

      }
    );

  }



  /* =========================================================
     RESIZE
  ========================================================= */

  let resizeTimer = null;


  window.addEventListener(
    'resize',
    function () {

      if (resizeTimer !== null) {

        window.clearTimeout(
          resizeTimer
        );

      }


      resizeTimer =
        window.setTimeout(
          function () {

            resizeTimer = null;


            resetCardsForViewport();

          },
          120
        );

    },
    {
      passive: true
    }
  );



  /* =========================================================
     NORMAL PAGE LOAD
  ========================================================= */

  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      function () {

        initProductCards(
          document
        );


        resetCardsForViewport();

      },
      {
        once: true
      }
    );

  } else {

    initProductCards(
      document
    );


    resetCardsForViewport();

  }



  /* =========================================================
     SHOPIFY THEME EDITOR
  ========================================================= */

  document.addEventListener(
    'shopify:section:load',
    function (event) {

      /*
       * Shopify can replace section HTML.
       * Remove initialization flag from
       * newly loaded cards before starting.
       */

      if (
        event.target.matches &&
        event.target.matches(
          '[data-fur-product-card]'
        )
      ) {

        delete event.target
          .dataset
          .furProductCardInitialized;

      }


      if (
        event.target.querySelectorAll
      ) {

        const cards =
          event.target.querySelectorAll(
            '[data-fur-product-card]'
          );


        cards.forEach(
          function (card) {

            delete card
              .dataset
              .furProductCardInitialized;

          }
        );

      }


      initProductCards(
        event.target
      );


      resetCardsForViewport();

    }
  );

})();